/* eslint-disable @typescript-eslint/ban-types */
import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useStyles } from '../../UserManagement/UserProfileStyles'
import { Box, Button, Divider } from '@mui/material'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import SuccessSnackBar from '../../HOC/SuccesSnackBar'
import ErrorSnackBar from '../../HOC/ErrorSnackBar'
import { useSelector } from 'react-redux'
import { RootState } from '../../../reducers'
import { consultCase, setCaseData } from '../../../actions'

export default function ConsultCase({ open, onClose, handleConsult }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { user } = useSelector((state: RootState) => state.userLogin)
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const [openErrorSnackBar, setOpenErrorSnackBar] = useState(false)
  const data = useSelector((state: RootState) => state.getCaseData)
  const updateView = async () => {
    if (data) {
      await dispatch(
        setCaseData({
          pathologistId: data.pathologistId,
          pathologist: data.pathologist,
          caseNumber: data.caseNumber,
          procedureCodeId: data.procedureCodeId,
          workflowId: updateWorklowStage(data.workflowId),
          patientName: data.patientName,
          caseId: data.caseId,
          nlOrderId: data.nlOrderId,
          userCaseWorkflowId: data.userCaseWorkflowId,
          slideStatusId: data.slideStatusId,
          mcFlag: data.mcFlag,
          statFlag: data.statFlag,
        }),
      )
    }
    handleConsult()
    setOpenSuccessSnackBar(true)
  }

  const updateWorklowStage = (type) => {
    switch (type) {
      case 'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS':
        return 'PRIMARY_DIAGNOSIS_ASSIGNED_CONSULT'
      case 'CORRECT_ASSIGNED_INPROGRESS':
        return 'CORRECT_ASSIGNED_CONSULT'
      case 'PRIMARY_DIAGNOSIS_ASSIGNED_READY':
        return 'PRIMARY_DIAGNOSIS_ASSIGNED_CONSULT'
      case 'CORRECT_ASSIGNED_READY':
        return 'CORRECT_ASSIGNED_CONSULT'
    }
  }

  const handleConsultCase = (event) => {
    dispatch(
      consultCase({
        caseId: data.caseId,
        userId: user,
      }),
    )
    setTimeout(updateView, 1500)
  }

  return (
    <Box className={`${classes.mt} , ${classes.mb}`}>
      {openSuccessSnackBar && <SuccessSnackBar message="Successfully consulted the case" />}
      {openErrorSnackBar && <ErrorSnackBar message="Consultation of case failed" />}
      <Dialog
        fullWidth
        maxWidth="sm"
        id="hello"
        classes={{ paper: classes.dialogHeight }}
        open={open}
        onClose={onClose}
      >
        <DialogTitle className={classes.dialogTitle}>Consult Case</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText className={classes.dialogContent}>
            Confirm that you are planning to consult other pathologists for this case. <br />
            By confirming, the case will be kept on hold until you resume to update and resulted.
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.buttonActions}>
          <Button
            className={`${classes.btn} ${classes.buttonMargin}`}
            onClick={handleConsultCase}
            endIcon={<CheckIcon />}
          >
            Confirm
          </Button>
          <Button onClick={onClose} variant="outlined" className={classes.buttonMargin} endIcon={<ClearIcon />}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}
